export const getBackgroundColorClassName = (backgroundColor: string | undefined): string => {
    switch (backgroundColor) {
        case 'color-black':
            return 'bg-black';
        case 'color-primary-lightViolet':
            return 'bg-primary-lightViolet';
        case 'color-primary-violet':
            return 'bg-primary-violet';
        case 'color-primary-darkViolet':
            return 'bg-primary-darkViolet';
        case 'color-primary-green':
            return 'bg-primary-green';
        case 'color-primary-blue':
            return 'bg-primary-blue';
        case 'color-primary-pink':
            return 'bg-primary-pink';
        case 'color-secondary-lemon':
            return 'bg-secondary-lemon';
        case 'color-secondary-lightBlue':
            return 'bg-secondary-lightBlue';
        case 'color-secondary-blue':
            return 'bg-secondary-blue';
        case 'color-secondary-violet':
            return 'bg-secondary-violet';
        case 'color-secondary-lightViolet':
            return 'bg-secondary-lightViolet';
        case 'color-secondary-pink':
            return 'bg-secondary-pink';
        case 'color-secondary-orange':
            return 'bg-secondary-orange';
        case 'color-secondary-salmon':
            return 'bg-secondary-salmon';
        case 'color-gray':
            return 'bg-gray';
        default:
            return 'bg-white';
    }
}

export const getFontColorClassName = (fontColor: string | undefined): string => {
    switch (fontColor) {
        case 'color-black':
            return 'text-primary-black';
        case 'color-primary-lightViolet':
            return 'text-primary-lightViolet';
        case 'color-primary-violet':
            return 'text-primary-violet';
        case 'color-primary-darkViolet':
            return 'text-primary-darkViolet';
        case 'color-primary-green':
            return 'text-primary-green';
        case 'color-primary-blue':
            return 'text-primary-blue';
        case 'color-primary-pink':
            return 'text-primary-pink';
        case 'color-secondary-lemon':
            return 'text-secondary-lemon';
        case 'color-secondary-lightBlue':
            return 'text-secondary-lightBlue';
        case 'color-secondary-blue':
            return 'text-secondary-blue';
        case 'color-secondary-violet':
            return 'text-secondary-violet';
        case 'color-secondary-lightViolet':
            return 'text-secondary-lightViolet';
        case 'color-secondary-pink':
            return 'text-secondary-pink';
        case 'color-secondary-orange':
            return 'text-secondary-orange';
        case 'color-secondary-salmon':
            return 'text-secondary-salmon';
        case 'color-gray':
            return 'text-gray';
        default:
            return 'text-white';
    }
}
